import {banService} from "@mecatran/ban-services-mjs";
import {banServicesConfigModel as banConfigModel} from "@mecatran/ban-services-lib-config";
import {loggerFactory} from "@mecatran/logger-factory";
import * as geojson from "./schema.mjs";
import {serializr} from "@mecatran/serializr-extensions";

var {
    BanServicesConfig
} = banConfigModel;

var { model } = geojson;

console.log('>>>',banService)
console.log('banConfigModel',banConfigModel)
console.log(loggerFactory)
console.log('geojson',geojson)
console.log('BanServicesConfig',BanServicesConfig)
console.log('serializr>',serializr)
console.log('geojson model',model)
console.log('model.Geojson',model.Geojson)
console.log('model.Properties',model.Properties);
var m = new model.Geojson(); console.log('>>',m.type)



var logger = loggerFactory.createLogger('BANLIB','info',false);

export class BanServicesLib{
    constructor(){
        var _banConfig = new BanServicesConfig(),
            _client = banService.createClient(); 
        ;

        Object.defineProperty(this,'setConfig',{
            value : function(banConfig){
                logger.info('Creating a new client');
                _banConfig = banConfig;
            },
            enumerable : true 
        });


        Object.defineProperty(this,'getConfig',{
            value : function(){ return _banConfig },
            enumerable : true 
        });

        Object.defineProperty(this,'search',{
            value : function(searchConfig){ 
                var searchConfig = searchConfig || _banConfig.search; 
                var promise = new Promise((resolve,reject)=>{
                    var callback = (data)=>{
                        var data = JSON.parse(data)
                        console.log('data',data, data.type)
                        BanServicesLib.deserialize(data)
                            .then(this.transform(searchConfig).bind(this))
                            .then(resolve)
                            .catch(reject)
                    }
                    _client.search(searchConfig, callback )
                });
                return promise;
            }
        });


    }

    transform(searchConfig){
        return (geojson)=>{
            var bounds = searchConfig.getBounds();
            if (bounds){
                console.log('transform',geojson);
                var filter = BanServicesLib.filterByBounds(bounds);
                geojson.setFeaturesFilter(filter);
            }
            return geojson;
        }
    }

    static deserialize(data){
        logger.info('data before deserialize:',data);
        var promise = new Promise((resolve,reject)=>{
            function callback(e,d){
                console.log('callback d:',d);
                if (e) { console.log(e)} // do not reject if error, the callback will be called again later (check if process completed)
                else resolve(d);
            }
            var ret = serializr.deserialize(model.Geojson, data, callback);
            console.log('ret',ret)
        });
        return promise; 
    }

    static filterByBounds(bounds){
        return (feature)=>{
            var lat = feature.getGeometry().getLatitude();
            var lon = feature.getGeometry().getLongitude();

            var swLat = bounds.getSouthWestPoint().getLatitude();
            var swLon = bounds.getSouthWestPoint().getLongitude(); 
            var neLat = bounds.getNorthEastPoint().getLatitude();
            var neLon = bounds.getNorthEastPoint().getLongitude();

            return ((lat <= neLat) && (lat >= swLat ) && (lon >= swLon) && (lon <= neLon));
        }
    }
}


